// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","router":"Layout_router__XiBXh","footer":"Layout_footer__OFT90"};